/*eslint-disable*/
export const getJobLocation = (data = {}) => {
    const { city_name, state_name, short_region, workmode, map_enable } = data;
    // console.log("getJobLocation", data);
  
    let location = "";
  
    if (city_name) {
      location += city_name;
    }
  
    if (short_region) {
      location += location ? `, ${short_region}` : short_region;
    } else if (state_name) {
      location += location ? `, ${state_name}` : state_name;
    }
  
    return map_enable ? location || "Remote" : "N/A";
  };